import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-primary-light p-6">
          <div className="bg-white p-8 rounded-2xl shadow-xl max-w-sm text-center animate-fade-in">
            <h2 className="text-title font-black text-text-main mb-4">Connection Interrupted</h2>
            <p className="text-text-muted font-medium text-body mb-6">
              We lost connection while loading the next step. Please check your network and try
              again.
            </p>
            <button
              onClick={() => window.location.reload()}
              className="w-full bg-primary text-white py-3 px-4 rounded-xl font-bold transition-all hover:bg-primary"
            >
              Reload Page
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
